import { toast } from "react-toastify";

// Centralized error handler
export const handleError = (error, customMessage = "Something went wrong. Please try again.") => {
  // Check for 401 Unauthorized error
  console.log("this is the error", error)
  if (error?.response?.status === 401) {
    // Clear local storage
    localStorage.clear();
    
    // Redirect to login page
    window.location.href = "/admin/auth/logout";
    
    return "Session expired. Please login again.";
  }

  // Extract error message from various possible error structures
  const errorMessage =
    error?.response?.data?.message || // From Axios response
    error?.message ||                 // From generic error object
    error ||                          // Fallback to raw error (if string)
    customMessage;                    // Default custom message if no error details

  // Display the error via toast
  toast.error(errorMessage);

  // Log the error for debugging (optional)
  console.error("Error:", error);

  // Return the message for further use (e.g., in Redux state)
  return errorMessage;
};